// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".root{display:flex;flex-direction:column;height:100%;position:relative}.root .segment-header{padding-bottom:5px}.root .line-chart{display:block;flex:1;margin-top:-8px;min-height:0}.root mp-context-menu{position:absolute;z-index:7000}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
